/**
 * Pill-shaped status indicator (DESIGN.md › Status Badges).
 * tone: 'ok' | 'pending' | 'alert' | 'neutral'
 */
const TONES = {
  ok: {
    pill: 'bg-status-ok-bg text-status-ok-text border-status-ok-border',
    dot: 'bg-status-ok-dot',
  },
  pending: {
    pill: 'bg-status-pending-bg text-status-pending-text border-status-pending-border',
    dot: 'bg-status-pending-dot',
  },
  alert: {
    pill: 'bg-status-alert-bg text-status-alert-text border-status-alert-border',
    dot: 'bg-status-alert-dot animate-pulse',
  },
  neutral: {
    pill: 'bg-surface-container text-on-surface-variant border-outline-variant/40',
    dot: 'bg-outline',
  },
};

export default function StatusBadge({ tone = 'neutral', dot = true, className = '', children }) {
  const t = TONES[tone] ?? TONES.neutral;
  return (
    <span
      className={`inline-flex items-center gap-1.5 h-[22px] px-2 rounded-full border text-[11px] font-semibold whitespace-nowrap ${t.pill} ${className}`}
    >
      {dot && <span className={`w-1.5 h-1.5 rounded-full ${t.dot}`} />}
      {children}
    </span>
  );
}
